module.exports = __webpack_public_path__ + "img/fi-rr-caret-up.26d00034.svg";